module.exports = __webpack_public_path__ + "img/address.beb67e13.png";